<div (click)="returnToSongLocation()"
     [class.show]="selectedSongSignal()"
     class="player fixed bottom-0 left-0 right-0 overflow-hidden md:rounded-tr-lg md:rounded-tl-lg cursor-pointer
            md:-translate-x-1/2 md:left-1/2 md:max-w-lg shadow-2xl">
  @if (selectedSong(); as song) {
    <div class="flex justify-between items-center pb-3 px-4 relative h-full">
      <!-- Song Info Section -->
      <div class="flex min-w-0 gap-x-4 flex-grow song-info -mt-4">
        <img [alt]="'Cover image for the song - ' + song.title + ', By - ' + song.artist" [src]="song.imageUrl"
             class="flex-none bg-gray-50 cover-image"
             height="48" imageLoader width="48">
        <div class="min-w-0 flex-auto flex flex-col justify-center">
          <span class="select-none text-white font-medium text-sm md:text-md max-[600px]:whitespace-normal ellipsis"
                isEllipsis>{{ song.title }}</span>
          <span class="select-none text-xs md:text-sm text-gray-200 opacity-90 ellipsis mt-0.5"
                isEllipsis>{{ song.artist }}</span>
        </div>
      </div>

      <!-- Player Controls Section -->
      <div class="flex items-center gap-x-4 -mt-4">
        <svg (click)="playPreviousSong()"
             [class.cursor-not-allowed]="!showControls()"
             [class.cursor-pointer]="showControls()"
             [class.disabled]="!showControls() || firstSongId === song.id"
             [class.opacity-0]="firstSongId === song.id"
             [class.text-gray-300]="!showControls()"
             [class.text-white]="showControls()"
             class="w-8 h-8"
             fill="none"
             stopPropagation
             stroke="currentColor"
             stroke-linecap="round"
             stroke-linejoin="round"
             stroke-width="2"
             viewBox="0 0 24 24"
             xmlns="http://www.w3.org/2000/svg">
          <path d="m12 19-7-7 7-7"/>
          <path d="m19 19-7-7 7-7"/>
        </svg>

        @if (isSongPlaying()) {
          <svg (click)="pauseVideo()"
               [class.cursor-not-allowed]="!showControls()"
               [class.cursor-pointer]="showControls()"
               [class.disabled]="!showControls()"
               [class.text-gray-300]="!showControls()"
               [class.text-white]="showControls()"
               class="w-9 h-9"
               fill="none"
               stopPropagation
               stroke="currentColor"
               stroke-linecap="round"
               stroke-linejoin="round"
               stroke-width="2"
               viewBox="0 0 24 24"
               xmlns="http://www.w3.org/2000/svg">
            <rect height="16" width="4" x="6" y="4"/>
            <rect height="16" width="4" x="14" y="4"/>
          </svg>
        } @else {
          <svg (click)="playVideo()"
               [class.cursor-not-allowed]="!showControls()"
               [class.cursor-pointer]="showControls()"
               [class.disabled]="!showControls()"
               [class.text-gray-300]="!showControls()"
               [class.text-white]="showControls()"
               class="w-9 h-9"
               fill="none"
               stopPropagation
               stroke="currentColor"
               stroke-linecap="round"
               stroke-linejoin="round"
               stroke-width="2"
               viewBox="0 0 24 24"
               xmlns="http://www.w3.org/2000/svg">
            <polygon points="5 3 19 12 5 21 5 3"/>
          </svg>
        }

        <svg (click)="playNextSong()"
             [class.cursor-not-allowed]="!showControls()"
             [class.cursor-pointer]="showControls()"
             [class.disabled]="!showControls() || lastSongId === song.id"
             [class.opacity-0]="lastSongId === song.id"
             [class.text-gray-300]="!showControls()"
             [class.text-white]="showControls()"
             class="w-8 h-8"
             fill="none"
             stopPropagation
             stroke="currentColor"
             stroke-linecap="round"
             stroke-linejoin="round"
             stroke-width="2"
             viewBox="0 0 24 24"
             xmlns="http://www.w3.org/2000/svg">
          <path d="m5 19 7-7-7-7"/>
          <path d="m12 19 7-7-7-7"/>
        </svg>

        @if (!isThisIphone) {
          <svg (click)="togglePlayAllSongs()"
               [attr.alt]="'Play All Songs'"
               [class.text-yellow-300]="playAllSongs()"
               [tp]="isMobileDevice() ? null : playAllSongs() ? 'Stop Play All' : 'Play All Songs'"
               aria-hidden="true"
               class="w-5 h-5 text-white cursor-pointer no-effect"
               fill="currentColor"
               height="20"
               preserveAspectRatio="xMidYMid meet"
               stopPropagation
               viewBox="0 0 358.000000 293.000000"
               xmlns="http://www.w3.org/2000/svg">
            <g fill="currentColor"
               stroke="none" transform="translate(0.000000,293.000000) scale(0.100000,-0.100000)">
              <path d="M81 2834 c-45 -37 -53 -79 -49 -246 3 -164 11 -186 79 -220 32 -17
                      120 -18 1419 -18 1323 0 1387 1 1419 18 64 34 72 65 69 255 l-3 169 -37 34
                      -38 34 -1414 0 -1414 0 -31 -26z"/>
              <path d="M85 1898 c-46 -36 -55 -73 -55 -230 0 -158 10 -193 63 -232 28 -21
                      36 -21 756 -21 678 0 729 1 754 18 51 33 61 60 65 188 6 175 -2 226 -45 266
                      l-34 33 -738 0 -738 0 -28 -22z"/>
              @if (playAllSongs()) {
                <rect height="1826" rx="70" ry="70" width="600" x="2100" y="0"/>
                <rect height="1826" rx="70" ry="70" width="600" x="2900" y="0"/>
              } @else {
                <path d="M2185 1826 c-40 -17 -84 -63 -101 -103 -11 -26 -14 -174 -14 -792 0
                      -512 3 -769 11 -788 24 -64 109 -122 179 -123 19 0 58 11 85 25 28 13 293 181
                      590 373 614 397 598 383 603 505 3 83 -17 130 -78 178 -50 39 -1108 719 -1137
                      730 -35 13 -103 10 -138 -5z"/>
              }
              <path d="M92 960 c-55 -34 -64 -71 -60 -249 5 -254 -22 -241 503 -241 437 0
                      437 0 475 63 18 28 20 51 20 190 0 176 -7 203 -63 237 -30 19 -53 20 -437 20
                      -389 0 -406 -1 -438 -20z"/>
            </g>
          </svg>
        }

        <svg (click)="openLyrics()"
             [tp]="isMobileDevice() ? null : 'Lyrics Lookup'"
             class="w-5 h-5 text-white cursor-pointer no-effect"
             fill="none"
             stopPropagation
             stroke="currentColor"
             stroke-linecap="round"
             stroke-linejoin="round"
             stroke-width="2"
             viewBox="0 0 24 24"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
          <path d="M14 2v6h6"/>
          <line x1="16" x2="8" y1="13" y2="13"/>
          <line x1="16" x2="8" y1="17" y2="17"/>
          <line x1="10" x2="8" y1="9" y2="9"/>
        </svg>

        <mypart-social-sharing
            [link]="song.youtube_id"
            shareColor="text-white"
            source="song"
            stopPropagation>
        </mypart-social-sharing>
      </div>

      <!-- Progress Bar Section -->
      <div class="progress-container mb-2">
        <!-- Time Display -->
        <div class="time-display">
          <span class="current-time">{{ currentTime() }}</span>
          <span class="duration">{{ duration() }}</span>
        </div>

        <!-- Progress Bar -->
        <div (click)="seekTo($event)"
             (mouseleave)="hidePreviewTime()"
             (mousemove)="showPreviewTime($event)"
             class="progress-bar">
          <!-- Buffer Progress -->
          <div [style.width.%]="bufferProgress()"
               class="buffer-progress">
          </div>
          <!-- Playback Progress -->
          <div [style.width.%]="progress()"
               class="playback-progress">
            <!-- Progress Handle -->
            <div class="progress-handle"></div>
          </div>
          <!-- Preview Time Tooltip -->
          @if (previewTime()) {
            <div [style.left.%]="previewPosition()"
                 class="preview-tooltip">
              {{ previewTime() }}
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
